import { render, staticRenderFns } from "./BlackDiamond75V2.vue?vue&type=template&id=f370146e&scoped=true"
import script from "./BlackDiamond75V2.vue?vue&type=script&lang=ts"
export * from "./BlackDiamond75V2.vue?vue&type=script&lang=ts"
import style0 from "./BlackDiamond75V2.vue?vue&type=style&index=0&id=f370146e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f370146e",
  null
  
)

export default component.exports